/**
 * Keep Judge.me product-card ratings visible and localized after Boost
 * asynchronously renders collection, search, and instant-search results.
 *
 * This adapter deliberately does not modify Boost filtering/search behavior or
 * Judge.me metafield HTML. It only normalizes the rendered preview badges.
 */
(function (window, document) {
  'use strict';

  var BADGE_SELECTOR = [
    '.template-collection .jdgm-preview-badge .jdgm-prev-badge',
    '.template-search .jdgm-preview-badge .jdgm-prev-badge',
    '.boost-pfs-search-suggestion-wrapper .jdgm-preview-badge .jdgm-prev-badge'
  ].join(',');

  var observer;

  function parseNumber(value) {
    var number = parseFloat(value);
    return isFinite(number) ? number : null;
  }

  function matchesBadge(element) {
    var matches = element && (element.matches || element.msMatchesSelector);
    return Boolean(matches && matches.call(element, BADGE_SELECTOR));
  }

  function getReviewCount(badge) {
    var value = badge.getAttribute('data-number-of-reviews');

    // Older customized instant-search code translated the attribute name too.
    // Restore the canonical Judge.me attribute when cached HTML still uses it.
    if (value === null) {
      value = badge.getAttribute('data-number-of-avis');
      if (value !== null) {
        badge.setAttribute('data-number-of-reviews', value);
        badge.removeAttribute('data-number-of-avis');
      }
    }

    var reviewCount = parseNumber(value);
    return reviewCount === null ? null : Math.max(0, Math.floor(reviewCount));
  }

  function normalizeBadge(badge) {
    if (!matchesBadge(badge)) return;

    var reviewCount = getReviewCount(badge);
    var averageRating = parseNumber(badge.getAttribute('data-average-rating'));

    if (reviewCount === null || averageRating === null || averageRating < 0 || averageRating > 5) return;

    var text = badge.querySelector('.jdgm-prev-badge__text');
    var stars = badge.querySelector('.jdgm-prev-badge__stars');

    badge.style.setProperty('display', 'block', 'important');
    badge.style.setProperty('visibility', 'visible', 'important');

    if (stars) {
      stars.style.setProperty('display', 'inline-block', 'important');
      stars.style.setProperty('visibility', 'visible', 'important');
      stars.setAttribute(
        'aria-label',
        averageRating.toFixed(2).replace('.', ',') + ' étoiles sur 5, ' + reviewCount + ' avis'
      );
    }

    if (text) {
      text.textContent = reviewCount + ' avis';
      text.style.setProperty('display', 'inline', 'important');
      text.style.setProperty('visibility', 'visible', 'important');
      text.style.setProperty('opacity', '1', 'important');
    }

    badge.setAttribute('data-fa-rating-ready', 'true');
  }

  function refresh(root) {
    if (!root) root = document;

    if (root.nodeType === 1 && matchesBadge(root)) {
      normalizeBadge(root);
    }

    if (!root.querySelectorAll) return;

    var badges = root.querySelectorAll(BADGE_SELECTOR);
    for (var index = 0; index < badges.length; index += 1) {
      normalizeBadge(badges[index]);
    }
  }

  function observe() {
    if (!window.MutationObserver || observer) return;

    observer = new window.MutationObserver(function (mutations) {
      for (var mutationIndex = 0; mutationIndex < mutations.length; mutationIndex += 1) {
        var addedNodes = mutations[mutationIndex].addedNodes;
        for (var nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex += 1) {
          refresh(addedNodes[nodeIndex]);
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    refresh(document);
    observe();

    // App extensions can finish their own styling after DOMContentLoaded.
    window.setTimeout(function () { refresh(document); }, 500);
    window.setTimeout(function () { refresh(document); }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})(window, document);
